import { useCanSelectSearchModel } from '#pplx/frontend/apps/ask/hooks/search-model-selection-hooks/useCanSelectSearchModel.js';
import { useThreadConfig } from '#pplx/frontend/apps/ask/providers/ThreadSettingsProviderShared.js';
import { usePreferredSearchModelForSearchMode } from '#pplx/frontend/apps/ask/search/hooks/usePreferredSearchModelForSearchMode.js';
import { useMaxUpsell } from '#pplx/frontend/apps/ask/subscription/hooks/useMaxUpsell.js';
import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
import { useIsSubscribed } from '#pplx/frontend/auth/useIsSubscribed.js';
import { useIsUserLoggedIn } from '#pplx/frontend/auth/userHooks.js';
import { useCallback } from 'react';
export function useSearchModeGateInfo() {
    const isUserLoggedIn = useIsUserLoggedIn();
    const canSelectSearchModel = useCanSelectSearchModel();
    const { getPreferredSearchModelForSearchMode } = usePreferredSearchModelForSearchMode();
    const { hasAccessToProFeatures } = useIsSubscribed();
    const shouldRenderMaxUpsell = useMaxUpsell();
    const { gpt4Limit, pplxAlphaLimit } = useThreadConfig();
    return useCallback((searchMode) => {
        // ASI gating is handled at submit time by useComputerBeforeSubmit
        if (searchMode === SearchMode.ASI) {
            return { isGated: false };
        }
        const searchModel = getPreferredSearchModelForSearchMode(searchMode);
        const canSelect = canSelectSearchModel(searchModel);
        if (canSelect) {
            return { isGated: false };
        }
        if (!isUserLoggedIn) {
            return { isGated: true, reason: 'auth', showMaxUpsell: false };
        }
        if (shouldRenderMaxUpsell(searchMode)) {
            return { isGated: true, reason: 'rate_limit', showMaxUpsell: true };
        }
        if (hasAccessToProFeatures) {
            if (searchMode === SearchMode.RESEARCH &&
                (!gpt4Limit.available || !pplxAlphaLimit.available)) {
                return { isGated: true, reason: 'rate_limit', showMaxUpsell: false };
            }
            return { isGated: true, reason: 'subscription', showMaxUpsell: true };
        }
        return { isGated: true, reason: 'subscription', showMaxUpsell: false };
    }, [
        isUserLoggedIn,
        canSelectSearchModel,
        getPreferredSearchModelForSearchMode,
        hasAccessToProFeatures,
        shouldRenderMaxUpsell,
        gpt4Limit,
        pplxAlphaLimit,
    ]);
}
//# sourceMappingURL=useSearchModeGateInfo.js.map